<svg height="100%" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M1.28185 22.4956C-0.42728 19.6838 -0.427284 16.3162 1.28184 13.5044L6.2062 5.40293C7.47882 3.30924 9.97398 2 12.6915 2L23.3085 2C26.026 2 28.5212 3.30923 29.7938 5.40292L34.7182 13.5044C36.4273 16.3162 36.4273 19.6838 34.7182 22.4956L29.7938 30.5971C28.5212 32.6908 26.026 34 23.3085 34H12.6915C9.97398 34 7.47882 32.6908 6.20621 30.5971L1.28185 22.4956Z"
    class="background"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M18 11.9395L24.0607 18.0001L18 24.0608L16.9393 23.0001L21.1893 18.7501H12.25V17.2501H21.1893L16.9393 13.0001L18 11.9395Z"
    class="foreground"
  />
</svg>
